import { isEmpty, values } from 'ramda';
import { createAction } from 'redux-actions';

import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import { normalizeBy } from 'utils';

import * as types from './actionTypes';
import { dialogs } from './constants';
import { getCurveType, getWeeks } from './selectors';
import { checkSequence, resetEffectivity } from './utils';

export const setWeeks = createAction(types.SET_WEEKS, (weeks) => ({ weeks: normalizeBy(weeks, 'weekId') }));
export const updateWeekEffectivity = createAction(types.UPDATE_WEEK_EFFECTIVITY, (weekId, effectivity) => ({
	weekId,
	effectivity,
}));
export const resetWeeks = createAction(types.RESET_WEEKS);
export const changeCurveType = createAction(types.CHANGE_CURVE_TYPE, (type) => ({ type }));
export const reset = createAction(types.RESET_STARTUP_CURVE);
export const setIncorrectWeeks = createAction(types.SET_INCORRECT_WEEKS, (weekIds) => ({ weekIds }));
export const resetIncorrectWeeks = createAction(types.RESET_INCORRECT_WEEKS);

export const fetchWeeks = (campaignId) => async (dispatch) => {
	const response = await dispatch(
		fetch.actions.get(fetch.constants.urls.campaignStartupCurve, {
			uniqueReqID: 'get',
			replaceParams: { id: campaignId },
		}),
	);

	if (response.body.curveType) {
		dispatch(changeCurveType(response.body.curveType));
	}

	dispatch(setWeeks(response.body.records));
};

export const removeWeeks = () => (dispatch) => {
	dispatch(resetIncorrectWeeks());
	dispatch(dialog.actions.close(dialogs.curveSequence));
	dispatch(setWeeks([]));
};

export const saveStartupCurve = (campaignId) => (dispatch, getState) => {
	const state = getState();
	const weeks = getWeeks(state);

	const incorrectWeeks = checkSequence(weeks); // should determine if weeks are in sequence

	if (!isEmpty(incorrectWeeks)) {
		dispatch(setIncorrectWeeks(incorrectWeeks));
		dispatch(dialog.actions.open(dialogs.curveSequence, null, dialog.constants.ERROR));
		return false;
	}

	dispatch(resetIncorrectWeeks());
	dispatch(dialog.actions.close(dialogs.curveSequence));

	return dispatch(
		fetch.actions.put(fetch.constants.urls.campaignStartupCurve, {
			uniqueReqID: 'put.save',
			replaceParams: { id: campaignId },
			body: {
				records: values(weeks),
				curveType: getCurveType(state),
			},
		}),
	);
};

export const resetStartupCurve = (campaignId) => (dispatch, getState) => {
	const state = getState();
	const weeks = getWeeks(state);

	return dispatch(
		fetch.actions.put(fetch.constants.urls.campaignStartupCurve, {
			uniqueReqID: 'put.reset',
			replaceParams: { id: campaignId },
			body: {
				records: resetEffectivity(values(weeks)),
				curveType: getCurveType(state),
			},
			onSuccess: [
				resetIncorrectWeeks,
				dialog.actions.close.bind(null, dialogs.curveSequence, null, dialog.constants.ERROR),
			],
		}),
	);
};

export default {
	saveStartupCurve,
	updateWeekEffectivity,
	changeCurveType,
	fetchWeeks,
	reset, // Resets all user interaction that was not saved on BE
	resetWeeks, // Sets effectivity of all weeks to 0
	resetStartupCurve, // updates startupCurve on Be with effectivity 0,
	removeWeeks, // Makes weeks empty array and data will be fetched when component is mounted again
};
